/* unplugin-vue-components disabled */import { render } from "./AnswerButtonGroup.vue?vue&type=template&id=74a6c9f7&scoped=true"
import script from "./AnswerButtonGroup.vue?vue&type=script&lang=js"
export * from "./AnswerButtonGroup.vue?vue&type=script&lang=js"

import "./AnswerButtonGroup.vue?vue&type=style&index=0&id=74a6c9f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a6c9f7"]])

export default __exports__